import React, { createContext, useCallback, useContext, useState } from "react";
import api from "../Services/api";

export const ADMIN_PERMISSION_KEY = "is_admin";

interface PermissionContextType {
  isAdmin: boolean;
  checkAdminPermission: () => Promise<boolean>;
  clearPermission: () => void;
}

const PermissionContext = createContext<PermissionContextType>({
  isAdmin: false,
  checkAdminPermission: async () => false,
  clearPermission: () => {},
});

export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAdmin, setIsAdmin] = useState<boolean>(
    () => sessionStorage.getItem(ADMIN_PERMISSION_KEY) === "true"
  );

  const checkAdminPermission = useCallback(async (): Promise<boolean> => {
    try {
      await api.get("/all-files/");
      sessionStorage.setItem(ADMIN_PERMISSION_KEY, "true");
      setIsAdmin(true);
      return true;
    } catch {
      sessionStorage.setItem(ADMIN_PERMISSION_KEY, "false");
      setIsAdmin(false);
      return false;
    }
  }, []);

  const clearPermission = useCallback(() => {
    sessionStorage.removeItem(ADMIN_PERMISSION_KEY);
    setIsAdmin(false);
  }, []);

  return (
    <PermissionContext.Provider
      value={{ isAdmin, checkAdminPermission, clearPermission }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);
